import type { TransactionListResponseDto, TransactionResponseDto } from 'app/API/models';

export const normalizeTransactionsResponse = (
  response: TransactionListResponseDto | TransactionResponseDto[],
): TransactionResponseDto[] => {
  if (Array.isArray(response)) {
    return response;
  }
  return response?.transactions ?? [];
};
